import {formattedPropertyModel, RenderingServices} from '@wallaby-ui/core';

import {
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
  CellRendererParams,
} from 'src/js/model/cell_renderer_params';

const CASE_ID = 'caseid';
const HOSP_CASE_ID = 'hosp_caseid';
const NO_LINK = 'no_link_flag';
const DOCUMENT_ID = 'documentid';
const OUTPATIENT_DOC_ID = 'outpatient_main_doc';

export default function baseCasePatientAGFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {intl} = services;
  const {colDef, data, value} = params;

  const formatterParams = new CellRendererParams(
    colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
  );
  const newData = {...data};
  newData.icon = formatterParams.getIcon();
  let formattedValue = value;
  if (formatterParams.getFormat()) {
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formatterParams.getFormat(),
    });
    formattedValue = formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      value,
      intl
    );
  }

  let style;
  const caseId = data[HOSP_CASE_ID] || data[CASE_ID];
  const docId = data[DOCUMENT_ID] || data[OUTPATIENT_DOC_ID];
  const hasLink = !data[NO_LINK];
  if (caseId) {
    newData[CASE_ID] = caseId;
    newData[OUTPATIENT_DOC_ID] = docId;
    newData.value = formattedValue;
    if (!hasLink) {
      style = {paddingLeft: '50px'};
    }
  }

  return {...params, caseId, formattedValue, hasLink, newData, style};
}
